module.exports = __webpack_public_path__ + "img/but_huotui.1b6a1994.png";